<template>
  <div class="form-inline-group">
    <label
      v-for="option in options"
      :key="getOption(option).value"
      class="form-label"
      :for="`${index}${getOption(option).value}`"
    >
      <input
        v-bind="attrs"
        :id="`${index}${getOption(option).value}`"
        v-model="value"
        :title="title"
        :value="getOption(option)[useValue ? 'value' : 'label']"
        :type="type"
        class="form-input"
        :class="`form-${type}`"
      />
      <span class="form-option-text" v-html="getOption(option).label" />
      <span class="form-toggle" />
    </label>
  </div>
</template>

<script lang="ts" setup>
import type { FormFieldOption } from '~~/types'

const props = defineProps({
  index: { type: Number, default: 0 },
  type: String as () => 'checkbox' | 'radio',
  options: Array,
  modelValue: [String, Number, Boolean, Array],
  title: String,
  attrs: Object,
  useValue: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue'])

const getOption = (option: FormFieldOption) =>
  typeof option !== 'object'
    ? { value: slugify(option, { disableLowercase: true }), label: option }
    : option

const value = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<style lang="scss"></style>
